/* tslint:disable:no-parameter-reassignment */
import { FairOrderDetailState, RootState } from '@/store/types';
import { Module } from 'vuex';

export default {
  namespaced: true,
  state: {
    requestedDeliveryDay: null,
    requestedDeliveryDayFreshProducts: null
  },
  getters: {},
  actions: {},
  mutations: {
    setRequestedDeliveryDay(state, {requestedDeliveryDay}: { requestedDeliveryDay?: Date }) {
      state.requestedDeliveryDay = requestedDeliveryDay;
    },
    setRequestedDeliveryDayFreshProducts(
      state,
      {requestedDeliveryDayFreshProducts}: { requestedDeliveryDayFreshProducts?: Date }
    ) {
      state.requestedDeliveryDayFreshProducts = requestedDeliveryDayFreshProducts;
    },
    resetCheckoutState(state) {
      state.requestedDeliveryDay = null;
      state.requestedDeliveryDayFreshProducts = null;
    }
  }
} as Module<FairOrderDetailState, RootState>;
